import { render } from "./warningPop.vue?vue&type=template&id=4fb97302&scoped=true"
import script from "./warningPop.vue?vue&type=script&lang=js"
export * from "./warningPop.vue?vue&type=script&lang=js"

import "./warningPop.vue?vue&type=style&index=0&id=4fb97302&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb97302"]])

export default __exports__